import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const StructuresService = Services.structures;
const StructuresTypes = VuexTypes.structures;

export default {
  [StructuresTypes.STRUCTURES_LIST]: ({ commit, state }, page = 1) => {
    state.structuresList['status'] = statuses.LOADING;
    StructuresService.list(page).then((data) => {
      commit(StructuresTypes.STRUCTURES_LIST, data);
    }).catch((errResponse) => {
      commit(StructuresTypes.STRUCTURES_LIST, errResponse);
    });
  },
  [StructuresTypes.STRUCTURE_UPDATE_DATA]: ({ commit, state }, structureId) => {
    state.structureUpdateData['status'] = statuses.LOADING;
    StructuresService.editData(structureId).then((data) => {
      commit(StructuresTypes.STRUCTURE_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(StructuresTypes.STRUCTURE_UPDATE_DATA, errResponse);
    });
  },
  [StructuresTypes.STRUCTURE_CREATE_DATA]: ({ commit, state }) => {
    state.structureCreateData['status'] = statuses.LOADING;
    StructuresService.createData().then((data) => {
      commit(StructuresTypes.STRUCTURE_CREATE_DATA, data);
    }).catch((errResponse) => {
      commit(StructuresTypes.STRUCTURE_CREATE_DATA, errResponse);
    });
  },
  [StructuresTypes.STRUCTURE_CREATE]: ({ commit, state }, createData) => {
    state.structureCreate['status'] = statuses.LOADING;
    StructuresService.create(createData).then((data) => {
      commit(StructuresTypes.STRUCTURE_CREATE, data);
    }).catch((errResponse) => {
      commit(StructuresTypes.STRUCTURE_CREATE, errResponse);
    });
  },
  [StructuresTypes.STRUCTURE_UPDATE]: ({ commit, state }, { id, update }) => {
    state.structureUpdate['status'] = statuses.LOADING;
    StructuresService.update(id, update).then((data) => {
      commit(StructuresTypes.STRUCTURE_UPDATE, data);
    }).catch((errResponse) => {
      commit(StructuresTypes.STRUCTURE_UPDATE, errResponse);
    });
  },
  [StructuresTypes.ADD_USER]: ({ commit, state }, createData) => {
    state.addUser['status'] = statuses.LOADING;
    StructuresService.addUserWithRole(createData).then((data) => {
      commit(StructuresTypes.ADD_USER, data);
    }).catch((errResponse) => {
      commit(StructuresTypes.ADD_USER, errResponse);
    });
  },
  [StructuresTypes.DELETE_USER]: ({ commit, state }, deleteData) => {
    state.deleteUser['status'] = statuses.LOADING;
    StructuresService.deleteUserWithRole(deleteData).then((data) => {
      commit(StructuresTypes.DELETE_USER, data);
    }).catch((errResponse) => {
      commit(StructuresTypes.DELETE_USER, errResponse);
    });
  },
};
